import { API_BASE_URL } from '@/config/api';
import { defaultAppPromotionSettings, type AppPromotionSettings } from '@/config/appPromotion';
import { apiService } from '@/services/apiService';

type PromotionResponse = { settings: AppPromotionSettings | null };

async function readResponse(response: Response): Promise<PromotionResponse> {
  if (!response.ok) throw new Error(`App promotion request failed (${response.status})`);
  return response.json() as Promise<PromotionResponse>;
}

export async function fetchPublicAppPromotion(): Promise<AppPromotionSettings> {
  try {
    const response = await fetch(`${API_BASE_URL}/read/v1/service/app-promotion`);
    const { settings } = await readResponse(response);
    return settings ?? defaultAppPromotionSettings;
  } catch {
    return defaultAppPromotionSettings;
  }
}

export async function fetchAdminAppPromotion(): Promise<AppPromotionSettings> {
  const response = await fetch(`${API_BASE_URL}/api/admin/app-promotion`, {
    headers: { token: apiService.getToken() ?? '' },
  });
  const { settings } = await readResponse(response);
  return settings ?? defaultAppPromotionSettings;
}

export async function saveAdminAppPromotion(settings: AppPromotionSettings): Promise<AppPromotionSettings> {
  const response = await fetch(`${API_BASE_URL}/api/admin/app-promotion`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', token: apiService.getToken() ?? '' },
    body: JSON.stringify(settings),
  });
  const saved = await readResponse(response);
  if (!saved.settings) throw new Error('The server did not return saved settings');
  return saved.settings;
}
